import { render, staticRenderFns } from "./dataPlan.vue?vue&type=template&id=55dce64a&scoped=true"
import script from "./dataPlan.vue?vue&type=script&lang=js"
export * from "./dataPlan.vue?vue&type=script&lang=js"
import style0 from "./dataPlan.vue?vue&type=style&index=0&id=55dce64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dce64a",
  null
  
)

export default component.exports